"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactActionsMobile = require("./ContactActionsMobile");
Object.keys(_ContactActionsMobile).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactActionsMobile[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactActionsMobile[key];
    }
  });
});